<div class="product-selection-container w-full">
  <div class="grid grid-cols-3 gap-4 w-full">
    <!-- Column 1: Product selection + Contacts affaire -->
    <div>
      <!-- Tuile produits -->
      <p-card
        styleClass="mb-2 bg-zinc-900 border border-zinc-700"
        class="product-card"
      >
        <ng-template pTemplate="header">
          <div
            class="flex items-center justify-between px-3 py-2 bg-zinc-800 rounded-t-lg"
          >
            <div class="flex items-center">
              <i class="pi pi-box text-primary mr-2"></i>
              <h3 class="text-base font-medium m-0">Produits à programmer</h3>
            </div>
          </div>
        </ng-template>

        <div class="p-3 relative">
          <div
            *ngIf="loadingProducts"
            class="absolute inset-0 bg-zinc-900/70 z-10 flex items-center justify-center"
          >
            <div class="flex flex-col items-center">
              <p-progressSpinner
                [style]="{ width: '40px', height: '40px' }"
              ></p-progressSpinner>
            </div>
          </div>

          <div id="product-selection" class="flex flex-col gap-1">
            <div *ngIf="productGroup" class="mb-2">
              <h4 class="text-sm font-semibold text-neutral-400 mb-1">
                {{ productGroup.products.length }} produit{{
                  productGroup.products.length > 1 ? 's' : ''
                }}
                sélectionné{{ productGroup.products.length > 1 ? 's' : '' }}
              </h4>
              <div
                class="product-group-item border border-neutral-700 p-2 rounded-lg mb-2"
                [attr.data-products]="
                  getProductIdsString(productGroup.products)
                "
                [attr.data-group-name]="productGroup.productsNames"
                [attr.data-group-id]="productGroup.id"
                [attr.data-is-manual]="true"
              >
                <div class="flex justify-between items-center">
                  <span class="text-sm font-medium">{{
                    productGroup.productsNames
                  }}</span>
                  <span class="text-xs bg-neutral-900 px-2 py-1 rounded"
                    >{{ productGroup.totalDuration }} min</span
                  >
                </div>
                <p class="text-xs text-neutral-400 mt-1">
                  {{ productGroup.products.length }} produits
                </p>
              </div>
            </div>

            <div *ngIf="products && products.length">
              <h4 class="text-sm font-semibold text-neutral-400 mb-1">
                Produits disponibles
              </h4>
              <div *ngIf="loadingProducts" class="flex justify-center p-2">
                <p-progressSpinner
                  [style]="{ width: '24px', height: '24px' }"
                ></p-progressSpinner>
              </div>
              <p-scrollPanel styleClass="products-scroll">
                <div
                  *ngFor="let product of products"
                  class="product-item border p-2 rounded-lg mb-1"
                  [class.selected-for-group]="isProductSelected(product.id)"
                  [attr.data-product]="product.id"
                >
                  <div class="flex items-center">
                    <div class="flex-grow flex items-center min-w-0 mr-2">
                      <input
                        type="checkbox"
                        class="mr-2 shrink-0"
                        [checked]="isProductSelected(product.id)"
                        (click)="toggleProductSelection(product.id, $event)"
                      />
                      <span class="text-sm font-medium truncate">{{
                        product.product.name
                      }}</span>
                    </div>
                    <span
                      class="text-xs bg-neutral-800 px-2 py-1 rounded shrink-0 w-[70px] text-center"
                    >
                      {{ product.product.duration }} min
                    </span>
                  </div>
                  <p class="text-xs text-neutral-400 mt-1 ml-5 truncate">
                    {{ product.orderId || product.product.reference }}
                  </p>
                </div>
              </p-scrollPanel>
            </div>

            <div
              *ngIf="!products || products.length === 0"
              class="text-center p-3"
            >
              <p class="text-xs text-neutral-400">Aucun produit à programmer</p>
            </div>
          </div>
        </div>
      </p-card>

      <!-- Tuile Contacts affaire (vide) -->
      <p-card
        styleClass="bg-zinc-900 border border-zinc-700"
        class="affair-contacts-card"
      >
        <ng-template pTemplate="header">
          <div
            class="flex items-center justify-between px-3 py-2 bg-zinc-800 rounded-t-lg"
          >
            <div class="flex items-center">
              <i class="pi pi-address-book text-primary mr-2"></i>
              <h3 class="text-base font-medium m-0">Contacts affaire</h3>
            </div>
          </div>
        </ng-template>

        <div class="p-3">
          <p *ngIf="affairContacts.length === 0">
            <i> Aucun contact associé à cette affaire. </i>
          </p>
          <div
            class="border-b border-zinc-700 pb-3 mb-3 last:border-b-0 last:mb-0 last:pb-0"
            *ngFor="let contact of affairContacts"
          >
            <div class="text-white font-medium mb-2">
              {{ contact.lastName }} {{ contact.firstName }}
            </div>
            <div class="flex flex-col gap-1">
              <div class="text-sm text-zinc-300 flex items-center">
                <i class="pi pi-envelope text-zinc-400 mr-2 w-4"></i>
                <a href="mailto:{{ contact.email }}" class="hover:text-primary">
                  {{ contact.email }}
                </a>
              </div>
              <div
                *ngIf="contact.phoneNumber"
                class="text-sm text-zinc-300 flex items-center"
              >
                <i class="pi pi-phone text-zinc-400 mr-2 w-4"></i>
                <a
                  href="tel:{{ contact.phoneNumber }}"
                  class="hover:text-primary"
                  >{{ contact.phoneNumber }}</a
                >
              </div>
              <div
                *ngIf="contact.comment"
                class="text-sm bg-zinc-800 border border-zinc-600 p-2 rounded mt-2"
              >
                <div class="flex items-start">
                  <i
                    class="pi pi-comment text-zinc-400 mr-2 mt-0.5 shrink-0"
                  ></i>
                  <span class="text-zinc-200">{{ contact.comment }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </p-card>
    </div>

    <!-- Column 2: Affair information -->
    <div *ngIf="affair">
      <p-card
        styleClass="mb-2 bg-zinc-900 border border-zinc-700"
        class="affair-info-card"
      >
        <ng-template pTemplate="header">
          <div
            class="flex items-center justify-between px-3 py-2 bg-zinc-800 rounded-t-lg"
          >
            <div class="flex items-center">
              <i class="pi pi-folder text-primary mr-2"></i>
              <h3 class="text-base font-medium m-0">Informations affaire</h3>
            </div>
            <span
              class="text-xs px-2 py-1 bg-primary-900 text-primary-200 rounded-md"
            >
              {{ affair.marketType?.name || 'NC' }}
            </span>
          </div>
        </ng-template>

        <div class="p-3">
          <div class="flex justify-between items-center mb-3">
            <div class="text-xl font-bold text-primary">{{ affair.mlRef }}</div>
          </div>

          <div class="mb-3">
            <h4 class="text-sm font-semibold mb-1 flex items-center">
              <i class="pi pi-users mr-1 text-primary-400"></i>
              Clients
            </h4>
            <div class="pl-5">
              <div class="text-sm font-medium">
                {{ affair.finalCustomerFirstname }}
                {{ affair.finalCustomerLastname }}
              </div>
              <div class="flex flex-col gap-1 mb-2">
                <div
                  class="text-xs text-neutral-400 flex items-center"
                  *ngIf="affair.finalCustomerEmail"
                >
                  <i class="pi pi-envelope text-neutral-500 mr-1"></i>
                  <a
                    href="mailto:{{ affair.finalCustomerEmail }}"
                    class="hover:text-primary"
                  >
                    {{ affair.finalCustomerEmail }}
                  </a>
                </div>
                <div
                  class="text-xs text-neutral-400 flex items-center"
                  *ngIf="affair.finalCustomerPhone"
                >
                  <i class="pi pi-phone text-neutral-500 mr-1"></i>
                  <a
                    href="tel:{{ affair.finalCustomerPhone }}"
                    class="hover:text-primary"
                  >
                    {{ affair.finalCustomerPhone }}
                  </a>
                </div>
              </div>

              <div
                *ngIf="
                  affair.finalCustomerFirstnameSecondary ||
                  affair.finalCustomerLastnameSecondary
                "
                class="pt-2 mt-2 border-t border-zinc-700"
              >
                <div class="text-sm font-medium">
                  {{ affair.finalCustomerFirstnameSecondary }}
                  {{ affair.finalCustomerLastnameSecondary }}
                </div>
                <div class="flex flex-col gap-1">
                  <div
                    class="text-xs text-neutral-400 flex items-center"
                    *ngIf="affair.finalCustomerEmailSecondary"
                  >
                    <i class="pi pi-envelope text-neutral-500 mr-1"></i>
                    <a
                      href="mailto:{{ affair.finalCustomerEmailSecondary }}"
                      class="hover:text-primary"
                    >
                      {{ affair.finalCustomerEmailSecondary }}
                    </a>
                  </div>
                  <div
                    class="text-xs text-neutral-400 flex items-center"
                    *ngIf="affair.finalCustomerPhoneSecondary"
                  >
                    <i class="pi pi-phone text-neutral-500 mr-1"></i>
                    <a
                      href="tel:{{ affair.finalCustomerPhoneSecondary }}"
                      class="hover:text-primary"
                    >
                      {{ affair.finalCustomerPhoneSecondary }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <h4 class="text-sm font-semibold mb-1 flex items-center">
              <i class="pi pi-info mr-1 text-primary-400"></i>
              Informations
            </h4>
            <div class="pl-5">
              <div class="text-sm">
                Accompagnateur RENOV' :
                <i
                  class="tll fa-logo-{{ affair.erpSource }} text-{{
                    affair.erpSource
                  }} text-lg"
                ></i>
              </div>
              <div class="text-sm">
                Lié à Constéo : {{ affair.consteoId ? 'Oui' : 'Non' }}
              </div>
            </div>
          </div>

          <div class="mb-3">
            <h4 class="text-sm font-semibold mb-1 flex items-center">
              <i class="pi pi-map-marker mr-1 text-primary-400"></i>
              Adresse du chantier
            </h4>
            <div class="pl-5">
              <div class="text-sm">{{ affair.workSiteComposedAddress }}</div>
              <div class="text-sm">
                {{ affair.workSitePostalCode }} {{ affair.workSiteLocality }}
              </div>
            </div>
          </div>
        </div>
      </p-card>
    </div>

    <!-- Column 3: ERP sources info -->
    <div *ngIf="affair" class="flex flex-col gap-2">
      <p-card
        styleClass="mb-2 bg-zinc-900 border border-zinc-700"
        class="company-info-card"
      >
        <ng-template pTemplate="header">
          <div
            class="flex items-center justify-between px-3 py-2 bg-zinc-800 rounded-t-lg"
          >
            <div class="flex items-center">
              <i class="pi pi-building text-primary mr-2"></i>
              <h3 class="text-base font-medium m-0">Informations sociétés</h3>
            </div>
          </div>
        </ng-template>

        <div class="p-3">
          <!-- Avertissements pour ERPs manquants -->
          <div *ngIf="getMissingErpWarnings().length > 0" class="mb-3">
            <div
              *ngFor="let warning of getMissingErpWarnings()"
              class="warning-message p-2 mb-2 bg-yellow-900 border border-yellow-700 rounded text-yellow-200 text-sm"
            >
              <i class="pi pi-exclamation-triangle mr-2 text-yellow-300"></i>
              {{ warning }}
            </div>
          </div>

          <div
            *ngFor="let erpSource of getFilteredErpEntries()"
            class="mb-3 last:mb-0"
          >
            <div
              *ngIf="erpSource.value"
              class="erp-section border-b border-neutral-700 pb-2 last:border-b-0"
            >
              <div class="flex items-center justify-between mb-2">
                <div class="flex items-center gap-2">
                  <i
                    class="tll tll-16"
                    [ngClass]="[
                      getErpCssClass(erpSource.key),
                      getLogoClass(erpSource.key),
                    ]"
                  ></i>
                  <h4 class="text-sm font-medium m-0">
                    {{ erpSource.key | uppercase }}
                  </h4>
                </div>
              </div>

              <div
                *ngIf="erpSource.value.administrativeInternalNote"
                class="mb-3 administrative-note"
              >
                <div class="text-xs opacity-70 mb-1">Note administrative :</div>
                <div
                  class="note-content p-2 bg-neutral-800 rounded border border-neutral-700"
                  [innerHTML]="erpSource.value.administrativeInternalNote"
                ></div>
              </div>

              <div class="mb-2 pl-1" *ngIf="erpSource.value.userAssistant">
                <div class="flex items-center">
                  <i
                    class="pi pi-user mr-2 text-sm"
                    [ngClass]="getErpCssClass(erpSource.key)"
                  ></i>
                  <div>
                    <div class="text-xs opacity-70">Assistant(e)</div>
                    <div class="text-sm">
                      {{ erpSource.value.userAssistant.firstname }}
                      {{ erpSource.value.userAssistant.lastname }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="pl-1" *ngIf="erpSource.value.userTechnician">
                <div class="flex items-center">
                  <i
                    class="pi pi-user-plus mr-2 text-sm"
                    [ngClass]="getErpCssClass(erpSource.key)"
                  ></i>
                  <div>
                    <div class="text-xs opacity-70">Technicien</div>
                    <div class="text-sm">
                      {{ erpSource.value.userTechnician.firstname }}
                      {{ erpSource.value.userTechnician.lastname }}
                    </div>
                  </div>
                </div>
              </div>

              <div
                *ngIf="!erpSource.value.userTechnician"
                class="text-xs text-neutral-500 italic pl-1"
              >
                <i class="pi pi-info-circle mr-1"></i>
                Aucun technicien assigné
              </div>
            </div>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <!-- Fiche bureau - Full width -->
  <app-affair-office-file
    [fullAffairDetails]="fullAffairDetails"
    [loading]="fullAffairLoading"
    [affair]="affair"
    class="mt-4 mb-20 block w-full"
  ></app-affair-office-file>
</div>
